import React, { useEffect, useRef, useState } from 'react';
import { IoArrowBack } from 'react-icons/io5';
import { useLocation, useNavigate } from 'react-router-dom';
import { getLangName } from '../../components/helper';
import CustomButton from '../../components/button/button';
import successToast from '../../components/toasts/successToast';
import errorToast from '../../components/toasts/errorToast';
import { useDispatch } from 'react-redux';
import { draftedDetailsAction, sendToModelAction } from '../../redux/actions/translationAction';
import { Spinner } from 'react-bootstrap';

const PostEditSummary = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const leftDivRef = useRef(null);
    const rightDivRef = useRef(null);
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    // const updateParts = location.state.updatedParts;
    const sourceLang = location.state.sourceLang || "Eng";
    const targetLang = location.state.targetLang || "Kannada";
    const job_id = location.state.job_id || null;

    const [jobData, setJobData] = useState();
    const [updateParts, setUpdateParts] = useState([])

    // Sample data

    // Synchronize scrolling
    const handleScroll = (e) => {
        if (leftDivRef.current && rightDivRef.current) {
            leftDivRef.current.scrollTop = e.target.scrollTop;
            rightDivRef.current.scrollTop = e.target.scrollTop;
        }
    };

    const handleSend = () => {
        setLoading(true)
        dispatch(sendToModelAction({ job_id: job_id }, onSaveSuccess, onError))
    }

    const onSaveSuccess = (data) => {
        setLoading(false)
        successToast(data.data.message);
        navigate('/post-editing')
    };

    const onError = (data) => {
        setLoading(false)
        errorToast(data?.data?.message);
    };

    useEffect(() => {
        setLoading(true)
        dispatch(draftedDetailsAction({ job_id: job_id }, onSuccess, onError))
    }, [job_id])

    const onSuccess = (data) => {
        setJobData(data.data.data.translationJob);
        setUpdateParts(data.data.data.editedSegments);
        setLoading(false);
        successToast(data.data.message);
    };


    return (
        <div className='min-vh-100 d-flex flex-column h-100 bg-white'>
            {/* Header Bar */}
            <div className="w-100 d-flex justify-content-between align-items-center header border-bottom position-sticky top-0 bg-white py-2">
                <div className='d-flex'>
                    <span className="px-3 fs_16 cursor_pointer pb-1" onClick={() => navigate(-1)}>
                        <IoArrowBack />
                    </span>
                    <h2 className="fs_20 fw_400 fn_Roboto text-start pt-1">Review Post Editing</h2>
                </div>
                <div className='d-flex'>
                    <CustomButton className='cursor_pointer fs_18 pb-1 mx-1 d-flex align-items-center justify-content-center text-nowrap'
                        variant='primary' onClick={() => { successToast("Saved Successfully"); navigate('/post-editing') }}>
                        Save Draft
                    </CustomButton>
                    <CustomButton className='cursor_pointer fs_18 pb-1 mx-1 d-flex align-items-center justify-content-center text-nowrap'
                        variant='primary' onClick={handleSend}>
                        Send to Model
                    </CustomButton>
                </div>
            </div>

            {/* Scrollable Side-by-Side Section */}
            <div className="container py-2 h-100">
                {loading ?
                    <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
                        <Spinner animation="border" variant="primary" />
                    </div> :
                    <div className="row h-100">
                        {/* Left Column - Source */}
                        <div className="col-6">
                            <div className="rounded shadow-sm h-100 d-flex flex-column text-start border">
                                {/* Header inside the scrollable div */}
                                <div className="p-2 border-bottom bg-light">
                                    <h5 className="m-0 text-secondary">Source: {getLangName(jobData?.source_lang)}</h5>
                                </div>

                                {/* Scrollable Content */}
                                <div
                                    className="flex-grow-1 overflow-auto p-1"
                                    ref={leftDivRef}
                                    onScroll={handleScroll}
                                    style={{ maxHeight: '80vh' }} // Fixed height for scrolling
                                >
                                    {updateParts.map((part, index) => (
                                        <div key={index} className="p-2 border text-secondary rounded my-1">
                                            {part.source}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Right Column - Updated */}
                        <div className="col-6">
                            <div className="rounded shadow-sm h-100 d-flex flex-column text-start border">
                                {/* Header inside the scrollable div */}
                                <div className="p-2 border-bottom bg-light">
                                    <h5 className="m-0 text-primary">Edited: {getLangName(jobData?.target_lang)}</h5>
                                </div>

                                {/* Scrollable Content */}
                                <div
                                    className="flex-grow-1 overflow-auto p-1"
                                    ref={rightDivRef}
                                    onScroll={handleScroll}
                                    style={{ maxHeight: '80vh', fontSize: "13px", lineHeight: "1.7" }} // Fixed height for scrolling
                                >
                                    {updateParts.map((part, index) => (
                                        <div key={index} className="p-2 border rounded text-primary my-1">
                                            {part.edited}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div >
    );
};

export default PostEditSummary;
